export const getFilenameFromLink = (url) => {
  try {
    const decodedUrl = decodeURIComponent(url);
    return decodedUrl.split("/").pop();
  } catch (error) {
    console.error("Error extracting filename:", error);
    return "";
  }
};
